import { createReduxServiceModule } from '@onhandtech/onhand-fe-shared/lib/redux'
import type { RequestArgs } from '@onhandtech/onhand-fe-shared/lib/request'
import { createRequestError, formatEndpoint } from '@onhandtech/onhand-fe-shared/lib/request'
import type { AxiosError } from 'axios'
import { getConfig } from 'config/configuration'
import type { CreateSignupCodeResponse } from 'contracts/api/v4/signup-codes/create-signup-code.service'

import { createSignupCodeFailureSaga } from './sagas/create-signup-code-failure.saga'
import { createSignupCodeSuccessSaga } from './sagas/create-signup-code-success.saga'
import type { NormalisedCreateSignupCodeResponse } from './create-signup-code.module.types'
import { moduleName } from './create-signup-code.module.types'
import { handleSuccess } from './handle-success'

const { endpoints } = getConfig()

const args: RequestArgs<CreateSignupCodeResponse, NormalisedCreateSignupCodeResponse> = {
  url: formatEndpoint(endpoints.api.v4.signUpCodes),
  method: 'POST',
  handleFailure: (e: AxiosError) => createRequestError(e, moduleName),
  handleSuccess,
}

const createSignupCodeModule = () =>
  createReduxServiceModule<CreateSignupCodeResponse, NormalisedCreateSignupCodeResponse>({
    moduleName,
    args,
    sagas: {
      onRequestSuccessSaga: createSignupCodeSuccessSaga,
      onRequestFailureSaga: createSignupCodeFailureSaga,
    },
  })

export default createSignupCodeModule
